import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export const useAdminAccountsData = () => {
    const getAdminAccountsData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}admin/accounts${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postAdminAccountsData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}admin/accounts${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}admin/accounts${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putAdminAccountsData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}admin/accounts${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchAdminAccountsData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}admin/accounts${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteAdminAccountsData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}admin/accounts${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getAdminAccountsData,
        postAdminAccountsData,
        putAdminAccountsData,
        patchAdminAccountsData,
        deleteAdminAccountsData
    };

};